import React, { useState, useRef, useEffect } from "react";
import { FaPlus } from "react-icons/fa";

const FilterBar = ({
  searchText,
  setSearchText,
  tags = [],
  handleKeyDown,
  handleManageSleeve,
  handleManageNegotiation,
  createContract,
  selectedOption,
  dropdownOptions,
  handleDropdownOptionClick,
  activeTab, 
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  return (
    <div className="manage-header-section">
      <div className="manage-tabs-container">
        <div className="manage-tabs-wrapper" id="nav-tab" role="tablist">
          <button 
            className={`manage-tab-btn ${activeTab === 'contract' ? 'active' : ''}`} 
            onClick={handleManageSleeve}
          >
            Manage Contract
          </button>
          <button 
            className={`manage-tab-btn ${activeTab === 'negotiation' ? 'active' : ''}`} 
            onClick={handleManageNegotiation}
          >
            <span>Manage Negotiation </span>
          </button>
        </div>
      </div>
      <div className="manage-filters-container">
        <button className="manage-btn-tabs-active" onClick={createContract}>
          <span>
            Create {activeTab === 'contract' ? 'Contract' : 'Negotiation'} <i className="bi bi-plus-lg" />
          </span>
        </button>
        <div className="manage-custom-dropdown-wrapper" ref={dropdownRef}>
          <button
            className={`dropdown-toggle-btn ${selectedOption
              .toLowerCase()
              .replace(" ", "-")}`}
            onClick={toggleDropdown}
            aria-expanded={isDropdownOpen}
          >
            <span>{selectedOption}</span>
            <svg
              className={`maange-dropdown-arrow ${isDropdownOpen ? "open" : ""}`}
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
            >
              <path
                d="M1 1L6 6L11 1"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {isDropdownOpen && (
            <div className="custom-dropdown-menu">
              {dropdownOptions.map((option, index) => (
                <button
                  key={index}
                  className={`dropdown-option ${option.color} ${selectedOption === option.label ? "selected" : ""
                    }`}
                  onClick={() => {
                    handleDropdownOptionClick(option);
                    setIsDropdownOpen(false);
                  }}
                >
                  <span className="option-label">
                    {selectedOption === option.label && (
                      <svg
                        className="check-icon"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M13 4L6 11L3 8"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                    {option.label}
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="search-box">
          <i className="bi bi-search"></i>
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={tags.length === 0 ? "Search Negotiation Name..." : ""}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
